import React, {useEffect, useRef, useState} from "react";
import mystyles from './styles/table.module.css';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axiosInstance from "../../AxiosInstance";
import { useTranslation } from 'react-i18next';

export default function TableComponent({fetchUrl, cols, rows, pull, withIndex, noPagination, defaultFilters}) {
    const { t } = useTranslation();
    const [activeFilter, setActiveFilter] = useState(null);
    const filterInputRef = useRef(null);
    const [filters, setFilters] = useState({...defaultFilters});

    const setField = (name, value) => {
        setFilters({
            ...filters,
            [name]: value
        });
    }

    const getValueFromString = (object, accessString) => {
        let accessParts = accessString.split(".");
        let value = object;

        for (let i = 0; i < accessParts.length; i++) {
            if (!value) {
                return "";
            }
            let accessPart = accessParts[i];
            value = value[accessPart];
        }

        return value;
    }

    const renderTh = (col, index) => {
        if(index === activeFilter && col.filter === true) {
            return (
                <th key={index}>
                    <div ref={filterInputRef}>
                        <input value={col.filterInternal ? filters[col.filterInternal] : filters[col.internal]} onChange={(event) => setField(col.filterInternal ? col.filterInternal : col.internal, event.target.value)} type={'text'} placeholder={`Filter ${col.title}`}/>
                    </div>
                </th>
            )
        } else {
            return <th key={index} onClick={() => setActiveFilter(index)}>{col.title} { (col.filterInternal ? filters[col.filterInternal] : filters[col.internal]) && "*"}</th>
        }
    }

    useEffect(() => {
        let isMounted = true;
        if(filters && fetchUrl) {
            const queryParams = Object.entries(filters)
                .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                .join("&");
            const url = `${fetchUrl}/?${queryParams}`;
            axiosInstance.get(url).then((response) => {
                if (isMounted) {
                    if(noPagination) {
                        pull(response.data)
                    } else {
                        pull(response.data.results)
                    }
                }
            });
        }
        return () => {
            isMounted = false;
        };
    }, [filters])

    return (
        <div className={mystyles.tableWrapper}>
        <table className={`${mystyles.table}`}>
            <thead>
                <tr>
                    {withIndex && <th>#</th>}
                    {cols.map((col, index) => (
                        renderTh(col, index)
                    ))}
                </tr>
            </thead>
            <tbody>
            {rows.map((row, index) => (
                <tr key={index}>
                    {withIndex && <td>{index + 1}</td>}
                    {cols.map((col, colIndex) => (
                        <td key={colIndex}>
                            {col.buttons ?
                                <span className={mystyles.actionButtons}>
                                            {col.buttons.map((button, buttonIndex) => (
                                                <div key={buttonIndex} role={'button'} onClick={() => {button.onClick(row.id)}}>
                                                    <FontAwesomeIcon icon={button.icon} color={button.color}/>
                                                </div>
                                            ))
                                            }
                                        </span>
                                :
                                <>
                                    {col.image ?
                                        <img src={getValueFromString(row,col.image.url)} alt={col.title} width={"50px"} height={"50px"} style={{borderRadius: "5px", objectFit: "contain", backgroundColor: "#F7F8F9"}}/>
                                        :
                                        <>
                                        {
                                            col.isBoolean ? <span>{getValueFromString(row, col.internal) ? t('common.yes') : t('common.no')}</span> :
                                                <>
                                                    { col.code ? <div className={'d-flex justify-content-center'}>{col.code(row, getValueFromString(row, col.internal))}</div>
                                                        :
                                                        <span>{getValueFromString(row, col.internal)}</span>
                                                    }
                                                </>
                                        }
                                        </>
                                    }
                                </>
                            }
                        </td>
                    ))}
                </tr>
            ))}
            </tbody>
        </table>
        </div>
    )
}